export default "__VITE_ASSET__ptJ_owwd__"